/** Couleurs de marque alignées sur le dashboard prestataire */
export const DASHBOARD_BRAND_PRIMARY = '#51beee';
export const DASHBOARD_BRAND_PRIMARY_DARK = '#3aa8d4';
export const DASHBOARD_BRAND_PRIMARY_LIGHT = '#9dd9f7';
export const DASHBOARD_BRAND_PRIMARY_SOFT = 'rgba(81, 190, 238, 0.18)';
export const DASHBOARD_BRAND_GRADIENT = `linear-gradient(90deg, ${DASHBOARD_BRAND_PRIMARY} 0%, ${DASHBOARD_BRAND_PRIMARY_DARK} 100%)`;
export const SIDEBAR_BRAND_BG = '#f5f6f8';
